<template>
    <div>
        <h3 class="page-title">班级</h3>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/homework/student' }">学生 {{$route.query.student_name}}</el-breadcrumb-item>
            <el-breadcrumb-item>所在班级</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="toolbar" v-if="isAdmin">
            <el-button type="success" size="small" @click="courseSelectFormVisible = true; getCourseList()">加入班级</el-button>
        </div>
        <div>
            <el-table v-loading="loading" empty-text="无数据" :data="dataList" stripe style="width: 100%">
                <el-table-column prop="name" label="班级名称"></el-table-column>
                <el-table-column prop="teacher_name" label="教师">
                    <template slot-scope="scope">
                        <router-link v-if="isAdmin" :to="{path: '/homework/course/'+ scope.row.id +'/teacher', query:{name: scope.row.name }}">{{scope.row.teacher_name}}</router-link>
                        <span v-else>{{scope.row.teacher_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lessons_count" label="课程数量" align="center">
                    <template slot-scope="scope">
                        <router-link :to="{path: '/homework/course/'+ scope.row.id +'/lesson', query:{name: scope.row.name, teacher_id:scope.row.teacher_id}}">{{scope.row.current_lessons_count}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="students_count" label="学员数量" align="center">
                    <template slot-scope="scope">
                        <router-link :to="{path: '/homework/course/'+ scope.row.id +'/student', query:{name: scope.row.name, teacher_id:scope.row.teacher_id}}">{{scope.row.students_count}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="班级状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="tagsColor[scope.row.status]" size="mini">{{tagsTxt[scope.row.status]}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作" width="160" align="left">
                    <template slot-scope="scope" v-if="isAdmin || scope.row.teacher_id == user_profile.id">
                        <el-button plain type="danger" size="mini" v-if="scope.row.status != 'started'" @click="del(scope.row)" icon="el-icon-delete">移出班级</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.page"
                :page-sizes="[20, 50, 100]"
                :page-size="params.per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="加入班级" :visible.sync="courseSelectFormVisible">
            <el-form :model="courseSelectForm" ref="courseSelectForm" :rules="courseSelectFormRules" label-width="80px">
                <el-form-item prop="course_id" label="班级">
                    <el-select
                        size="small"
                        v-model="courseSelectForm.course_id"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="输入班级名称"
                        :remote-method="getCourseList"
                        :loading="courseLoading">
                        <el-option
                          v-for="item in courseList"
                          :key="item.id"
                          :label="item.name + ' - ' + item.teacher_name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="courseSelectFormVisible = false">取消</el-button>
                <el-button type="primary" @click="addStudentToCourse">确认</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      total: 0,
      loading: true,
      teacherLoading: true,
      params: {
        student_id: this.$route.params.id * 1 || '',
        status: '',
        name: '',
        page: 1,
        per_page: 20,
        order_by: '',
        fields: ''
      },
      tagsColor: {
        waiting: 'warning',
        started: 'success',
        finished: 'danger'
      },
      tagsTxt: {
        waiting: '未开班',
        started: '进行中',
        finished: '已停课'
      },
      courseList: [],
      courseLoading: false,
      courseSelectForm: {
        course_id: ''
      },
      dataList: [],
      courseSelectFormVisible: false,
      courseSelectFormRules: {
        course_id: [{ required: true, message: '请选择班级' }]
      }
    }
  },

  created () {
    this.getDataList()
  },
  computed: {
    ...mapGetters(['isAdmin', 'user_profile'])
  },
  methods: {
    getDataList () {
      this.loading = true
      this.$api.courses
        .list(this.params)
        .then(data => {
          this.total = data.total
          this.dataList = data.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$error(err)
        })
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getDataList()
    },
    handleSizeChange (size) {
      this.params.per_page = size
      this.getDataList()
    },
    getCourseList (name) {
      this.courseLoading = true
      var params = Object.assign({}, { fields: ['id', 'name'], status: 'enable', page: 1, per_page: 1000, name })
      this.$api.courses.list(params).then(data => {
        this.courseList = data.data
        this.courseLoading = false
      }).catch(err => {
        console.log(err)
        this.courseLoading = false
      })
    },
    courseSelect (target) {
      this.courseSelectForm = {
        student_id: target.id
      }
      this.courseSelectFormVisible = true
    },
    addStudentToCourse () {
      if (!this.courseSelectForm.course_id) return
      this.$api.courses.add_student(this.courseSelectForm.course_id, this.params.student_id).then(data => {
        this.$message({
          type: 'success',
          message: `加入成功!`
        })
        this.courseSelectForm.course_id = ''
        this.courseSelectFormVisible = false
        this.getDataList()
      }).catch(err => {
        console.log(err)
      })
    },
    del ({ id, name }) {
      this.$confirm(`你确认将学生 [${this.$route.query.student_name}] 从 [${name}]班级中移出?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.courses.delete_student(id, this.params.student_id).then(data => {
            this.$message({
              type: 'success',
              message: `退出成功!`
            })
            this.getDataList()
          }).catch(err => {
            console.log(err)
          })
        })
        .catch(() => {})

    }
  }
}
</script>

<style  lang="scss">
  .title {
    text-align: center;
  }
  .tag{
    padding:15px;
    margin:15px;
    max-height:140px;
    overflow-y:auto;
    padding-right:0;
  }
  .tag span{
    display:block;
    margin-bottom:10px;
  }
  .tag span i{
    float:right;
    margin-top:7px;
  }
  .flex .el-form-item__content {
     display:flex;
     margin-left:0!important;
  }
  .flex .el-button {
     margin-left:10px;
  }
  .list{
    overflow:hidden;
    border-top:1px solid #ccc;
    margin-top:20px;
    padding-top:15px;
  }
</style>
